// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RejectedCustomerRefundCandidateStatus {
  Rejected = "REJECTED",
  Recreated = "RECREATED",
}
export default RejectedCustomerRefundCandidateStatus;

export function rejectedCustomerRefundCandidateStatusToVariant(
  rejectedCustomerRefundCandidateStatus: RejectedCustomerRefundCandidateStatus
) {
  switch (rejectedCustomerRefundCandidateStatus) {
    case RejectedCustomerRefundCandidateStatus.Rejected:
      return "warning";

    case RejectedCustomerRefundCandidateStatus.Recreated:
      return "success";
  }
}
